import {
  Component,
  OnInit,
  ViewChild,
  Output,
  Input,
  EventEmitter,
  AfterViewInit,
  OnChanges,
  SimpleChanges
} from '@angular/core'
import { AceComponent, AceConfigInterface } from 'ngx-ace-wrapper'
import 'brace'
import 'brace/mode/json'
import 'brace/mode/python'
import 'brace/snippets/python'
import 'brace/ext/searchbox.js'
import 'brace/ext/language_tools'
import 'brace/theme/github'
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog'
import { ChangeDetectorRef } from '@angular/core'

@Component({
  selector: 'jml-lib-code-editor',
  templateUrl: './code-editor.component.html',
  styleUrls: ['./code-editor.component.scss']
})
export class CodeEditorComponent implements AfterViewInit, OnChanges {
  @ViewChild(AceComponent, { static: false }) componentRef?: AceComponent

  @Input() syntax!: string
  @Input() code!: string
  @Input() saveButtonLabel!: string
  @Input() saveIcon = 'pi pi-save'
  @Input() readonly = false
  @Output() editedCode = new EventEmitter<string>()
  @Output() setDirty = new EventEmitter<boolean>()
  isValid = true
  isDirty = false
  newValue = ''
  isInitialized = false

  public aceconfig: AceConfigInterface

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private cdRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.componentRef.directiveRef
      .ace()
      .getSession()
      .on('changeAnnotation', () => {
        const annotations = this.componentRef.directiveRef.ace().getSession().getAnnotations()
        this.isValid = !annotations.some((annotation) => annotation['type'] === 'error')
        this.cdRef.detectChanges()
      })
    this.focus()
  }

  public focus() {
    setTimeout(() => {
      this.componentRef.directiveRef.ace().focus()
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.code) {
      this.newValue = this.code
    }
    if (!this.saveButtonLabel) {
      this.saveButtonLabel = 'Speichern'
    }

    this.aceconfig = {
      theme: 'github',
      readOnly: this.readonly
    }

    this.handleDirty()
  }

  handleDirty() {
    // handleDirty() is triggered before the data binding updates the model (this.newValue)
    // ngModelChange is not supported by ace. Hence, a timeout of 0 seconds is added.
    setTimeout(() => {
      this.isDirty = this.newValue !== this.code
      this.setDirty.emit(this.isDirty)
    })
  }

  save() {
    // emits edited code back to "caller". Update logic happens in parent.
    this.editedCode.emit(this.newValue)
  }
}
